export default {
    'daily-report': 'Daily report',
    'from-date': 'From date',
    'to-date': 'To date',
    'daily-date': 'Daily date',
    'visit-details': 'Visit details',
    'distributed-samples': 'Distributed samples'
}